export interface MinimalUser {
  role: string;
}

/** Roles allowed into the /review console (admin ∪ agent). Mirrors the server
 * REVIEWER_ROLES; kept inline so this guard stays self-contained (like
 * console/guard.ts) and unit-testable without the @shared alias. */
const REVIEWER_ROLES = ["admin", "agent"];

/**
 * Where to redirect a visitor of the /review console, or null if allowed.
 * Reviewers are admin ∪ agent; everyone else (unauthenticated, end_user) goes
 * to "/" (login or chat). Mirrors console/guard.ts adminRedirect.
 */
export function reviewerRedirect(user: MinimalUser | null): string | null {
  if (user === null || !REVIEWER_ROLES.includes(user.role)) return "/";
  return null;
}
